module.exports = __webpack_public_path__ + "img/3.74bd4eac.png";